class MobileMenu {
  constructor() {
    this.init();
    this.setupDrawerListener();
  }

  init() {
    // Seleccionar todos los elementos del menú con submenús, tanto padres como hijos
    const menuItems = document.querySelectorAll('.mobile-menu__item.has-submenu');
    
    menuItems.forEach(item => {
      const linkWrapper = item.querySelector('.mobile-menu__link-wrapper');
      const titleButton = item.querySelector('.mobile-menu__title-button');
      const toggle = item.querySelector('.mobile-menu__toggle--icon');
      const fullLink = item.querySelector('.mobile-menu__full-link');
      
      // Evento para el botón de título (que contiene el texto)
      titleButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleSubmenu(item, toggle);
      });
      
      // Detener propagación cuando se haga clic en el enlace completo
      if (fullLink) {
        fullLink.addEventListener('click', (e) => {
          // Solo prevenir navegación si tiene submenú
          if (item.classList.contains('has-submenu')) {
            e.preventDefault();
            e.stopPropagation();
            this.toggleSubmenu(item, toggle);
          }
        });
      }
    });
  }

  setupDrawerListener() {
    // Observar cuando se abre el drawer del menú móvil
    const menuDrawer = document.querySelector('[data-drawer-id="menu"]');
    if (menuDrawer) {
      // Usar MutationObserver para detectar cuando cambia aria-hidden
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            const isOpen = menuDrawer.getAttribute('aria-hidden') === 'false';
            if (isOpen) {
              this.openFirstSubmenu();
            } else {
              this.closeAllSubmenus();
            }
          }
        });
      });
      
      observer.observe(menuDrawer, { 
        attributes: true, 
        attributeFilter: ['aria-hidden'] 
      });
    }
  }

  openFirstSubmenu() {
    // Buscar el primer item de menú de nivel principal que tenga un submenú
    const firstLevelItem = document.querySelector('.mobile-menu__items > .mobile-menu__item.has-submenu');
    
    if (firstLevelItem) {
      // Abrir el primer nivel (el item que contiene el submenu level-1)
      if (!firstLevelItem.classList.contains('active')) {
        firstLevelItem.classList.add('active');
        const firstLevelToggle = firstLevelItem.querySelector(':scope > .mobile-menu__link-wrapper .mobile-menu__toggle--icon');
        if (firstLevelToggle) {
          firstLevelToggle.setAttribute('aria-expanded', 'true');
        }
      }
      
      // Buscar el primer submenú de nivel 1 (el elemento ul) dentro de este item
      const firstSubmenuLevel1 = firstLevelItem.querySelector('.mobile-submenu.level-1');
      if (firstSubmenuLevel1) {
        // Buscar el primer item (li) dentro de este submenú de nivel 1 que tenga otro submenú (que será el level-2)
        const firstLevel2Item = firstSubmenuLevel1.querySelector('.mobile-menu__item.has-submenu');
        
        if (firstLevel2Item) {
          // Abrir el segundo nivel (el item que contiene el submenu level-2)
          if (!firstLevel2Item.classList.contains('active')) {
            firstLevel2Item.classList.add('active');
            const secondLevelToggle = firstLevel2Item.querySelector(':scope > .mobile-menu__link-wrapper .mobile-menu__toggle--icon');
            if (secondLevelToggle) {
              secondLevelToggle.setAttribute('aria-expanded', 'true');
            }
          }
        }
      }
    }
  }

  closeAllSubmenus() {
    // Cerrar todos los submenús cuando se cierre el drawer
    const activeItems = document.querySelectorAll('.mobile-menu__item.active');
    activeItems.forEach(item => {
      item.classList.remove('active');
      const toggle = item.querySelector('.mobile-menu__toggle--icon');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
  
  toggleSubmenu(item, toggle) {
    // Verificar si el elemento está activo actualmente
    const isCurrentlyActive = item.classList.contains('active');
    
    // Cerrar todos los submenús al mismo nivel
    const parent = item.parentElement;
    const siblings = parent.querySelectorAll('.mobile-menu__item.has-submenu');
    
    siblings.forEach(sibling => {
      if (sibling.classList.contains('active')) {
        sibling.classList.remove('active');
        const siblingToggle = sibling.querySelector('.mobile-menu__toggle--icon');
        if (siblingToggle) {
          siblingToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
    
    // Si el elemento no estaba activo, entonces lo activamos
    if (!isCurrentlyActive) {
      item.classList.add('active');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new MobileMenu();
});